var _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessagesNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00537109 8.92815L13.4213 15.6353L26.8372 8.92815C26.7876 8.07331 26.413 7.26981 25.7901 6.6822C25.1673 6.0946 24.3433 5.76736 23.487 5.76752H3.35558C2.4993 5.76736 1.67535 6.0946 1.0525 6.6822C0.429655 7.26981 0.0550355 8.07331 0.00537109 8.92815V8.92815Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8419 12.676L13.421 19.3865L0 12.676V22.5438C0 23.4336 0.353498 24.287 0.982727 24.9163C1.61196 25.5455 2.46538 25.899 3.35524 25.899H23.4867C24.3766 25.899 25.23 25.5455 25.8592 24.9163C26.4884 24.287 26.8419 23.4336 26.8419 22.5438V12.676Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0656,
    cy: 5.76753,
    r: 4.93428,
    fill: "#F65B2E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesNotification);
export default __webpack_public_path__ + "static/media/messages-notification.4af2d4eddbe69902c3554e211d653a5b.svg";
export { ForwardRef as ReactComponent };